import React, { useEffect, useState } from "react";
import { Button, Row, Col, Card, NavLink } from "react-bootstrap";
import { LAYOUT } from "constants.js";
import CsLineIcons from "cs-line-icons/CsLineIcons";
import Clamp from "components/clamp";
import { format } from "date-fns";
import _ from "lodash";
import PropTypes from "prop-types";

const Workex = ({ user, workex, tabHandler, ...props }) => {
  return (
    <Row className="g-0">
      <Col xs="auto" className="me-3">
        <div
          className="bg-foreground sw-7 sh-7 rounded-xl shadow d-flex flex-shrink-0 justify-content-center align-items-center"
          style={{ marginTop: "-6px" }}
        >
          {workex.icon && workex.icon !== "" ? (
            <img
              className="card-img rounded-xl sh-5 sw-5"
              src={workex.icon}
              alt="Workex Organization"
            />
          ) : (
            <div className="bg-gradient-light sw-5 sh-5 rounded-xl">
              <div className="text-white d-flex justify-content-center align-items-center h-100 text-small text-center lh-1">
                <i
                  className={`text-forground bi-person-badge`}
                  style={{ fontSize: "1.8rem" }}
                />
              </div>
            </div>
          )}
        </div>
      </Col>
      <Col>
        <p className="mb-0">
          <NavLink className="m-0 p-0" onClick={(e) => tabHandler("Workex")}>
            {workex.position} @ {workex.orgName}
          </NavLink>
          {workex.certificate && workex.certificate !== "" ? (
            <a
              href={workex.certificate}
              target="_blank"
              variant="foreground"
              size="sm"
              title="View Certificate"
              className="btn-icon btn-icon-only hover-outline ms-1"
              rel="noreferrer"
            >
              <CsLineIcons icon="content" />
            </a>
          ) : (
            ""
          )}
        </p>
        <p className="text-muted">
          {format(new Date(workex.fromDate), "dd MMM, yyyy")}
          {workex.tillDate && workex.tillDate !== ""
            ? ` - ${workex.tillDate}`
            : ""}
        </p>
      </Col>
    </Row>
  );
};

export default Workex;
Workex.propTypes = {
  user: PropTypes.object.isRequired,
  workex: PropTypes.object.isRequired,
};
